// Lissandra — Ice Tomb: Encases herself in ice (stasis for 1 turn), then
// shatters it to freeze all enemies for 1 turn and deal magic damage.

import { magicDamage } from "../../combat/DamageCalc";
import { effectiveStats } from "../UnitStats";
import type { Ability, AbilityHit } from "./Ability";

export const lissandraIceTomb: Ability = {
  id: "lissandraIceTomb",
  displayName: "Ice Tomb",
  description: "Becomes untargetable for 1 turn, then shatters to freeze all enemies for 1 turn and deal magic damage.",
  iconId: "LissandraR",

  targetShape({ caster, combat }) {
    const team = caster.team === "player" ? "enemy" : "player";
    const shape = [caster.pos];
    for (const e of combat.livingUnitsOf(team)) shape.push(e.pos);
    return shape;
  },

  computeHits({ caster, combat }): AbilityHit[] {
    const team = caster.team === "player" ? "enemy" : "player";
    const stats = effectiveStats(caster);

    const hits: AbilityHit[] = [
      { target: caster, amount: 0, type: "none", effect: { kind: "stasis", duration: 1 } },
    ];
    for (const e of combat.livingUnitsOf(team)) {
      hits.push({
        target: e,
        amount: magicDamage(stats.ap * 1.0 + 56),
        type: "magical",
        effect: { kind: "stun", duration: 1 },
      });
    }
    return hits;
  },
};
